import { getInstance } from '@router/auth'

const authService = getInstance()

export const permissionsService = {
  isVanishedAdmin() {
    return (
      authService.user.profile.permissions.organization === 'vanished' &&
      authService.user.profile.permissions.role === 'admin'
    )
  },
  isVanished() {
    return authService.user.profile.permissions.organization === 'vanished'
  },
  isAdmin() {
    return authService.user.profile.permissions.role === 'admin'
  },
  isUser() {
    return authService.user.profile.permissions.role === 'user'
  },
  loggedInUserOrg() {
    return authService.user.profile.permissions.organization
  },
}
